<div class="main-container">
  <h1 class="text-bold mb-3">{{'terms-conditions.title' | translate}} <strong></strong></h1>
  <p class="mb-4" [innerHTML]="'TERMS-CONDITIONS.DESCRIPTION.1' | translate"></p>
  <p class="mb-4" [innerHTML]="'TERMS-CONDITIONS.DESCRIPTION.2' | translate"></p>
</div>
<div class="btnr corporat mt-6 mb-2">
  <button type="button" id="cancel" class="tertiary" (click)="$event.preventDefault();emitCancel()"
    [innerHTML]="'DONTPERMIT' | translate"></button>
  <div class="flex items-center gap-10">
    <button type="button" id="onlySantander" class="secondary" (click)="emitAllowSantander($event)"
      [innerHTML]="'TERMSONLYSANTANDER' | translate"></button>
    <button type="button" id="allow" class="btn p-3" (click)="$event.preventDefault();emitAllow()"
      [innerHTML]="'PERMIT' | translate"></button>
  </div>
</div>